export const LABELS = {
  INDIVIDUAL_HANDLING_CONFIRMATION_RESULT: "個別取扱確認結果",
  EMPTY: "　",
  INDIVIDUAL_HANDLING_REASON: "個別取扱事由",
  STATUS: "ステータス",
  APPLICATION_NO: "申請番号",
  APPLICATION_DATE: "申請日　",
  APPLICATION_TYPE_CODE: "申請種別　",
  CONTRACT_TYPE: "契約形態",
  CONTRACT_ROUTE: "契約ルート",
  PARTICULAR_RATE_FLAG: "特別料率",
  COMPANY_NAME: "事業者名",
  MERCHANTS_NAME: "加盟店名",
  INDUSTRY: "業態　　",
  APPLICATION_START: "～",
  SERVICE_NAME: "サービス名",
  CONTRACT_STATUS: "契約形態",
  CONTRACT_DIRECTLY: "直接",
  CONTRACT_COMPREHENSIVE: "包括",
  ALL: "ALL",
} as const;

// 一覧の1ページ当たりの件数
export const LIST_PAGE_SIZE = 10;

// プレースホルダーの内容
export const PLACE_APPLICATION = {
  DATE_FORMAT: "YYYY/MM/DD",
  FONT_SIZE: "30文字以内",
  FONT_SIZE_MERCHANTS: "15文字以内",
} as const;
